module.exports = {"member_seq":1,"member_uid":"a1b2c3","createdAt":null,"updatedAt":null,"activities":[{"activity_title":"Jsmine","activity_kind":"study","activity_description":"I had a study group about 'Design Pattern'. It gave me how to make clean code.","activity_imageURL":"jsmine.png","activity_date":"Mar, 2018"},{"activity_title":"Here","activity_kind":"presentation","activity_description":"I had a presentation about Github Pages in 'WITHINNOVATION'. I was shared it to design team.","activity_imageURL":"withinnovation.png","activity_date":"Feb, 2018"}]}


//////////////////
// WEBPACK FOOTER
// ./docs/json/activity.json
// module id = d3+i
// module chunks = 1